// extracted by mini-css-extract-plugin
export default {"CategoryLeaderContainer":"CategoryLeader_CategoryLeaderContainer__q8XFF","Title":"CategoryLeader_Title__Ib4h9","RankingContainer":"CategoryLeader_RankingContainer__u67Pn"};